import {Swiper, SwiperSlide} from "swiper/react";
import {Navigation} from "swiper/modules";
import CardSlide from "./CardSlide";
import React, {useState} from "react";
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import {useActions} from "../../../hooks/useActions";
import {cardMatchesDeckFilter} from "../../../utils/cardFilters";

function DeckSlider() {

    const {user, isLoading, cards, deckEditorFilter} = useTypedSelector(state => state.auth);

    let [showDeckPopup, setShowDeckPopup] = useState('none');

    const {setDeck, setSystemMessage, createDeck, editDeck, deleteDeck} = useActions();

    const [deckName, setDeckName] = useState("");

    const handleSave = () => {
        const trimmed = deckName.trim();
        if (trimmed.length >= 1 && trimmed.length <= 20) {
            editDeck(activeDeck.id, trimmed);
        } else {
            setSystemMessage({
                isVisible: true,
                type: 'info',
                text: 'Deck name must be between 1 and 20 characters',
                action: null
            })
        }
    };


    let deckCards = user.deck.cards;
    if (deckCards === null) {
        deckCards = [];
    }

    const activeDeck = user.decks.find((deck) => deck.is_active) ?? user.decks[0];

    let deckPopupClasses = 'deckPopupContainer';

    if (showDeckPopup !== 'none') {
        deckPopupClasses += ' deckPopupContainerActive';
    }
    return <div className={'deckSliderContainer'}>
        <div className="deck-slider ">
            <Swiper
                modules={[Navigation]}
                spaceBetween={7}
                loop={false}
                threshold={10}
                touchRatio={1}
                touchStartPreventDefault={true}
                navigation={{
                    prevEl: '.swiper-button-prev-deck',
                    nextEl: '.swiper-button-next-deck',
                }}
                breakpoints={{
                    0: {
                        slidesPerView: 5, // phones, tablets, small laptops
                    },
                    2200: {
                        slidesPerView: 7, // full HD+ desktops
                    },
                }}
            >

                {Object.keys(deckCards)
                    .filter(item => {

                        // @ts-ignore
                        const cardId = cards[deckCards[item].id].id;
                        return cardMatchesDeckFilter(cardId, cards[cardId], deckEditorFilter);
                    })
                    .map((item, index) => {

                        if (deckCards) {
                            const cardId = deckCards[item].id;
                            const deckAmount = deckCards[item].amount;

                            return <SwiperSlide key={index + '_deck'}>

                                <CardSlide card={cards[cardId]} amount={deckAmount} isDeck={true}/>
                            </SwiperSlide>;
                        }
                    })}

            </Swiper>
            <div className="swiper-button-prev swiper-button-prev-deck"></div>
            <div className="swiper-button-next swiper-button-next-deck"></div>
        </div>

        <div className={'deckSelectContainer'}>
            <select className='DeckSelect' name="DeckSelect"
                    value={activeDeck.id}
                    onChange={(e) => {
                        if (isLoading) {
                            return;
                        }
                        setDeck(Number(e.target.value))
                    }
                    }
                    onMouseDown={(e) => e.stopPropagation()}
            >
                {user.decks.map((deck) => (
                    <option key={deck.id} value={deck.id}>
                        {deck.name + ' (' + (deck.total_amount ?? 0) + ')'}
                    </option>
                ))}
            </select>

            <div className='DeckSelectEdit' onClick={() => {
                setDeckName('');
                setShowDeckPopup('edit');
            }}></div>

            <div className='DeckSelectCopy' onClick={async () => {
                type DeckEntry = { id: number; amount: number | null };

                const cardsInDeck: DeckEntry[] = Array.isArray(user?.deck?.cards)
                    ? (user!.deck.cards as DeckEntry[])
                    : (Object.values(user?.deck?.cards ?? {}) as DeckEntry[]);

                const list = cardsInDeck
                    .map((c) => {
                        const cardMeta = cards?.[c.id];
                        const name = cardMeta?.name ?? `id:${c.id}`;
                        return `${name} x ${c.amount ?? 0}`;
                    })
                    .join('\n');

                // Modern API
                try {
                    await navigator.clipboard.writeText(list);
                } catch {
                    // Fallback for older/insecure contexts
                    const ta = document.createElement('textarea');
                    ta.value = list;
                    document.body.appendChild(ta);
                    ta.select();
                    document.execCommand('copy');
                    document.body.removeChild(ta);
                }

                setSystemMessage({
                    isVisible: true,
                    type: 'info',
                    text: 'The deck list has been copied to your clipboard. To use it, paste it with Ctrl+V (or Command+V on Mac) into any text field.',
                    action: null
                })
            }}></div>

            <div className='DeckSelectCreateNew' onClick={() => {

                setDeckName(`New Deck - ${user.decks.length + 1}`);
                setShowDeckPopup('new');
            }}></div>

        </div>
        <div className={deckPopupClasses} onClick={() => {
            setShowDeckPopup('none');
        }}>
            <div className={'deckSelectBox'}
                 onClick={(e) => e.stopPropagation()}
            >
                <div className='deckSelectCaption'>
                    {showDeckPopup === 'edit' ? 'Edit' : 'New'}
                </div>

                <label className='deckPopupLabel' htmlFor="deckName">Enter deck name:</label>
                <input
                    className="deckPopupInput"
                    type="text"
                    id="deckName"
                    name="deckName"
                    placeholder={
                        showDeckPopup === "edit"
                            ? activeDeck?.name ?? "deck name"
                            : "New deck"
                    }
                    value={deckName}
                    onChange={(e) => setDeckName(e.target.value)}
                    minLength={1}
                    maxLength={20}
                    required
                    pattern="^[A-Za-z0-9_ ]{1,20}$"
                    autoComplete="off"
                    onMouseDown={(e) => e.stopPropagation()}
                />
                <div className={'deckPopupButtonContainer'}>
                    {showDeckPopup === "edit" && (
                        <div
                            className="deckPopupSaveDelete"
                            onClick={() => {

                                if (user.decks.length < 2) {
                                    setSystemMessage({
                                        isVisible: true,
                                        type: 'info',
                                        text: 'You cannot delete the last deck!',
                                        action: null
                                    })

                                    return;
                                }
                                deleteDeck(activeDeck.id);
                                setShowDeckPopup("none");
                            }}
                        />
                    )}
                    <div className={'deckPopupSaveButton'} onClick={() => {
                        if (showDeckPopup === "edit") {
                            handleSave();
                        }
                        if (showDeckPopup === "new") {
                            createDeck(deckName);
                        }
                        setShowDeckPopup('none');
                    }}></div>
                </div>
            </div>
        </div>

    </div>
}

export default DeckSlider;